import React, { useEffect, useState } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import RefreshBtn from "Components/UI/Tables/RefreshBtn";

const createRows = (accounts) => {
  return accounts.map((a) => {
    return [
      a.Id,
      a.BookingDate,
      Math.abs(a.Amount),
      a.EndCustomerPaidInvoice?.Comment,
      a.EndCustomerPaidInvoice?.OCR,
      a.Description,
      a.EndCustomerPaidInvoice.EndCustomerName, // ELLER EndCustomerPaidInvoice.EndCustomerName
      a.EndCustomerPaidInvoice.Address,
      a.EndCustomerPaidInvoice.PostalNr,
      a.EndCustomerPaidInvoice.City,
    ];
  });
};

export default function EndcustomerUnplacedTable({
  accounts,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
  rowsPerPage,
  totalRows,
  onRowClick,
}) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const rows = createRows(accounts);
    setRows(rows);
  }, [accounts]);

  const columns = [
    {
      name: "Id",
      label: "ID",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      name: "Bokföringsdatum",
      options: {
        filter: false,
      },
    },
    {
      name: "Belopp",
      options: {
        filter: false,
      },
    },
    {
      name: "Notering",
      options: {
        filter: false,
      },
    },
    {
      name: "Bet Referens",
      options: {
        filter: false,
      },
    },
    {
      name: "Bet Övrig referens",
      options: {
        filter: false,
      },
    },
    {
      name: "Bet Namn",
      options: {
        filter: false,
      },
    },
    {
      name: "Bet Adress",
      options: {
        filter: false,
      },
    },
    {
      name: "Bet Postnummer",
      options: {
        filter: false,
      },
    },
    {
      name: "Bet Ort",
      options: {
        filter: false,
      },
    },
  ];

  const options = {
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    downloadOptions: {
      separator: ";",
      filename: "client_accounts.csv",
    },
    onChangePage: (currentPage) => onChangePage(currentPage),
    onChangeRowsPerPage: (numberOfRows) => onChangeRowsPerPage(numberOfRows),
    rowsPerPage: rowsPerPage,
    onRowClick: (_, rowMeta) => {
      if (onRowClick) {
        onRowClick(rows[rowMeta.dataIndex][0]);
      }
    },
    page: currentPage,
    count: totalRows,
    rowsPerPageOptions: [10, 30, 100],
    textLabels: {
      body: {
        noMatch: "",
      },
    },
    customToolbar: () => {
      return (
        <>
          <RefreshBtn />
        </>
      );
    },

    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
